import { MultilingualWidgetConfig } from '../dashboard.widgets.config';

interface QuickNotesContent {
  title: string;
  lastUpdated: string;
  placeholder: string;
  saveButton: string;
}

const generateQuickNotesContent = (lang: 'en' | 'de'): string => {
  const content: Record<'en' | 'de', QuickNotesContent> = {
    en: {
      title: 'Shift Notes',
      lastUpdated: 'Last updated: 2:15 PM',
      placeholder: `# Handover Notes
- Room 301: IV needs changing at 4pm
- Dr. Williams will visit Room 305 at 3pm
- Check on medication delivery for floor 4
- Schedule updated: staff meeting moved to 5pm

Remember to document all patient interactions in EMR system.`,
      saveButton: 'Save Note',
    },
    de: {
      title: 'Schichtnotizen',
      lastUpdated: 'Letzte Aktualisierung: 14:15 Uhr',
      placeholder: `# Übergabenotizen
- Zimmer 301: IV muss um 16 Uhr gewechselt werden
- Dr. Weber wird Zimmer 305 um 15 Uhr besuchen
- Medikamentenlieferung für Etage 4 überprüfen
- Zeitplan aktualisiert: Mitarbeiterbesprechung auf 17 Uhr verschoben

Denken Sie daran, alle Patienteninteraktionen im elektronischen Patientenaktensystem zu dokumentieren.`,
      saveButton: 'Notiz speichern',
    },
  };

  const { title, lastUpdated, placeholder, saveButton } = content[lang];

  return `
    <div style="display: flex; flex-direction: column; height: 100%;">
      <div style="margin-bottom: 12px; display: flex; justify-content: space-between; align-items: center;">
        <div style="font-weight: 600; color: #282a32;">${title}</div>
        <div style="font-size: 0.85rem; color: #686b87;">${lastUpdated}</div>
      </div>
      <div style="flex: 1; position: relative;">
        <textarea style="width: 100%; height: 100%; padding: 12px; border: 1px solid #eff1f6; border-radius: 8px; resize: none; font-family: 'Be Vietnam Pro', sans-serif; font-size: 0.9rem; color: #282a32; background-color: #fdfcff;">${placeholder}</textarea>
      </div>
      <div style="display: flex; justify-content: flex-end; margin-top: 12px;">
        <button style="background-color: #434ce8; color: white; border: none; border-radius: 8px; padding: 8px 16px; font-size: 0.85rem; font-weight: 500; cursor: pointer; font-family: 'Be Vietnam Pro', sans-serif;">
          ${saveButton}
        </button>
      </div>
    </div>`;
};

export const quickNotesWidget: MultilingualWidgetConfig = {
  id: 'quick-notes',
  translations: {
    en: {
      title: 'Quick Notes',
      content: generateQuickNotesContent('en'),
    },
    de: {
      title: 'Schnellnotizen',
      content: generateQuickNotesContent('de'),
    },
  },
  x: 4,
  y: 4,
  w: 2,
  h: 3,
};
